var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "weui-cell",
      class: {
        "vux-tap-active": _vm.isLink || !!_vm.link,
        "weui-cell_access": _vm.isLink || !!_vm.link,
        "vux-cell-no-border-intent": !_vm.borderIntent,
        "vux-cell-disabled": _vm.disabled
      },
      style: _vm.style,
      on: { click: _vm.onClick }
    },
    [
      _c("div", { staticClass: "weui-cell__hd" }, [_vm._t("icon")], 2),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "vux-cell-bd",
          class: {
            "vux-cell-primary":
              _vm.primary === "title" && _vm.valueAlign !== "left"
          }
        },
        [
          _c(
            "p",
            [
              _vm.title || _vm.hasTitleSlot
                ? _c(
                    "label",
                    {
                      staticClass: "vux-label",
                      class: _vm.labelClass,
                      style: _vm.labelStyles
                    },
                    [
                      _vm._t("title", function() {
                        return [_vm._v(_vm._s(_vm.title))]
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("after-title")
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "inline-desc",
            [
              _vm._t("inline-desc", function() {
                return [_vm._v(_vm._s(_vm.inlineDesc))]
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "weui-cell__ft", class: _vm.valueClass },
        [
          _vm._t("value"),
          _vm._v(" "),
          _vm._t("default", function() {
            return [_vm._v(_vm._s(_vm.value))]
          }),
          _vm._v(" "),
          _vm.isLoading ? _c("i", { staticClass: "weui-loading" }) : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("child")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e948aa6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e948aa6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
// module id = null
// module chunks = 